import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Star, Facebook } from 'lucide-react';
import { businessInfo, serviceAreas } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 py-16">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-xl font-bold text-white uppercase mb-4">
              {businessInfo.name}
            </h3>
            <p className="body-medium text-gray-400 mb-6 max-w-md">
              Premium mobile car detailing services throughout the Lower Mainland. 
              Professional-grade products, ceramic coating protection, and the convenience 
              of mobile service that comes to you.
            </p>
            
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-white" />
                <a 
                  href={`tel:${businessInfo.phone}`}
                  className="body-small text-gray-300 hover:text-white transition-colors"
                >
                  {businessInfo.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-white" />
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="body-small text-gray-300 hover:text-white transition-colors"
                >
                  {businessInfo.email}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={16} className="text-white" />
                <span className="body-small text-gray-300">Abbotsford, BC</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a 
                href={businessInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="body-small transition-colors hover:scale-105 transform"
                style={{
                  background: 'linear-gradient(45deg, #f9ce34, #ee2a7b, #6228d7)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                {businessInfo.instagram}
              </a>
              <a 
                href={businessInfo.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="body-small transition-colors hover:scale-105 transform flex items-center space-x-2"
                style={{
                  color: '#1877f2'
                }}
              >
                <Facebook size={16} />
                <span>{businessInfo.facebook}</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('booking-walkthrough')}
                  className="body-small text-gray-400 hover:text-white transition-colors"
                >
                  Book Now
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('gallery')}
                  className="body-small text-gray-400 hover:text-white transition-colors"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('testimonials')}
                  className="body-small text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Reviews
                </button>
              </li>
              <li>
                <Link
                  to="/service-areas"
                  data-testid="footer-service-areas-link"
                  className="body-small text-gray-400 hover:text-white transition-colors"
                >
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Areas & Services grid moved to dedicated /service-areas hub page */}

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 py-8">
          <div className="text-center">
            <p className="body-small text-gray-400">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;